import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const AccessControlGuard: CanActivateFn = () => {
  const router = inject(Router);

  // Check if this tab has been marked as access denied
  // This happens when user directly pastes a URL without coming from Veeva
  const accessDenied = sessionStorage.getItem('accessDenied');

  if (accessDenied === 'true') {
    console.log(
      'AccessControlGuard: Blocking route - access denied flag is set',
    );
    // Navigate to access-denied route instead
    router.navigate(['access-denied'], { replaceUrl: true });
    return false;
  }

  console.log('AccessControlGuard: Allowing route - no access restrictions');
  return true;
};
